export type ExpiryStatus = {
  expiring: boolean;
  timeframe: string | null;
};

export function getCardExpiryStatus(expMonth: number, expYear: number): ExpiryStatus {
  if (expMonth < 1 || expMonth > 12) {
    throw new Error('Invalid expMonth: must be 1-12');
  }
  const currentYear = new Date().getFullYear();
  if (expYear > currentYear + 20) {
    throw new Error(`Invalid expYear: must be between ${currentYear} and ${currentYear + 20}`);
  }
  const today = new Date();
  const now = today.getTime();

  // JavaScript months are 0-indexed, so convert expMonth (1-12) to 0-11
  const expDate = new Date(expYear, expMonth - 1, 1);
  // Advance to next month, then setDate(0) to get last day of expMonth
  expDate.setMonth(expDate.getMonth() + 1);
  expDate.setDate(0);
  const expTime = expDate.getTime();

  const diffMs = expTime - now;
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  let expiring = false;
  let timeframe = null;

  if (diffDays <= 90) {
    expiring = true;

    if (diffDays >= 75) {
      timeframe = 'about 3 months';
    } else if (diffDays >= 45) {
      timeframe = 'about 2 months';
    } else if (diffDays >= 30) {
      timeframe = 'about a month';
    } else if (diffDays >= 14) {
      const weeks = Math.ceil(diffDays / 7);
      timeframe = `about ${weeks} week${weeks > 1 ? 's' : ''}`;
    } else if (diffDays > 0) {
      timeframe = `${diffDays} day${diffDays > 1 ? 's' : ''}`;
    } else {
      timeframe = 'expired';
    }
  }

  return { expiring, timeframe };
}
